

export function truncate(name: string, length: number = 25, ending: string = "...") {
    if (!name) {
        return "";
    }
    if (name.length > length) {
        return name.substring(0, length - ending.length) + ending;
    }
    return name;
}

export function getJsonForGql(data) {
    return JSON.stringify(data).replace(/"([^(")"]+)":/g, "$1:");
    // return JSON.stringify(data).replace(/"([^(")"]+)":/g, "$1:").replace(/"/g, '\\"')
}
